import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";

// Get initial user data from localStorage
const storedUser = localStorage.getItem("user");
let initialUser = null;
let isInitialTokenValid = false;

if (storedUser) {
  try {
    initialUser = JSON.parse(storedUser);
    // Basic validation - check if user object has required properties
    isInitialTokenValid = initialUser && initialUser.token && initialUser.userData;
  } catch (error) {
    localStorage.removeItem("user");
  }
}

// Get initial app settings from localStorage
const loadAppSettings = () => {
  try {
    const storedSettings = localStorage.getItem('appSettings');
    if (storedSettings) {
      return JSON.parse(storedSettings);
    }
  } catch (error) {
    console.error('Error loading app settings from localStorage:', error);
  }
  
  // Return default settings
  return {
    appTheme: 'teal',
    appDarkMode: false,
    appGradientEnabled: true,
    appHeaderFixed: true,
    appHeaderInverse: false,
    appSidebarFixed: true,
    appSidebarGrid: false,
  };
};

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: {
    auth: {
      user: isInitialTokenValid ? initialUser : null,
      isAuthenticated: isInitialTokenValid,
      tokenExpiry: null,
    },
    appSettings: loadAppSettings(),
  },
});